module.exports = __webpack_public_path__ + "static/img/4areaA_13.72a6e85.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_13.png
// module id = 908
// module chunks = 1